module.exports = __webpack_public_path__ + "static/media/CapsuleCollection.999e46b7.jpg";